import { Button, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import BasicLayout from "../../../components/BasicLayout/index";
import ButtonAsLink from "../../../components/common/ButtonAsLink";
import FallBack from "../../../components/common/FallBack/FallBack";
import Tables from "../../../components/common/Table/Table";
import { useDeleteAction } from "../../../components/Hooks/useDeleteAction";
import useExportCsv from "../../../components/Hooks/useExportCsv";
import useTableSearch from "../../../components/Hooks/useTableSearch";
import {
	getAllProductSecondaryCategories,
	softDeleteSingleProductSecondaryCategory,
} from "../../../store/actions/products/secondaryCategory/categories.action";
import { DeleteModel } from "../../../utils/DeleteModel";
import { formatFileName } from "../../../utils/helper";

const ProductSecondaryCategory = (props) => {
	const [getColumnSearchProps] = useTableSearch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);

	const dispatch = useDispatch();
	const categories = useSelector((state) => state.productSecondaryCategory.categories || []);
	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getAllProductSecondaryCategories());
	}, [dispatch]);

	let dataSource = [];
	if (categories.length > 0) {
		dataSource = categories.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
		dataSource = dataSource.map((row, index) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			key: row.id,
		}));
	}

	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteSingleProductSecondaryCategory, setIsModalVisible);
	}

	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			...getColumnSearchProps("name"),
		},
		{
			title: "Code",
			dataIndex: "code",
			key: "code",
			...getColumnSearchProps("code"),
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					record={record}
					confirm={confirm}
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Secondary categories Removing has been cancelled"
					linkUrl={`/products/secondary/categories`}
					placeholder="Please enter reason to delete secondary categories"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					update={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.productSecondaryCategories.filter(
									(item) => item === "update"
							  )?.length > 0
							? "true"
							: false
					}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.productSecondaryCategories.filter(
									(item) => item === "delete"
							  )?.length > 0
							? "true"
							: false
					}
					view={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.productSecondaryCategories.filter(
									(item) => item === "read"
							  )?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];

	const fileName = formatFileName("product-categories", "xlsx", admin);
	let downloadData = categories.map((data) => {
		let newData = {
			name: data.name,
			code: data.code,
			url: data.url,
			primaryCategory: data?.primaryCategory?.name,
			createdAt: data.createdAt,
		};
		return newData;
	});

	const handleError = (error) => {
		message.error(error.message);
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : permissionArr?.products?.productSecondaryCategories?.filter(
							(item) => item === "export"
					  )?.length > 0 && downloadData?.length !== 0 ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : null}
					{permissionArr === "all" ? (
						<ButtonAsLink
							text="Add New Secondary Category"
							link="/products/secondary/categories/add"
						/>
					) : permissionArr?.products?.productSecondaryCategories?.filter(
							(item) => item === "write"
					  )?.length > 0 ? (
						<ButtonAsLink
							text="Add New Secondary Category"
							link="/products/secondary/categories/add"
						/>
					) : null}
				</div>
				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Secondary Categories: ${categories.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default ProductSecondaryCategory;
